import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = ["id", "name", "value", "checked", "disabled"]
const _hoisted_3 = ["id", "name", "value", "checked", "disabled"]
const _hoisted_4 = ["for"]
const _hoisted_5 = ["for"]

import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'SegmentControl',
  props: {
    modelValue: {},
    valueA: {},
    valueB: {},
    labelA: { default: 'A' },
    labelB: { default: 'B' },
    disabled: { type: Boolean },
    ariaLabel: { default: 'Segment control' },
    name: { default: 'segment-control' },
    size: { default: 'md' }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emits = __emit;

const idA = computed(() => `segment-option-${props.valueA}`);
const idB = computed(() => `segment-option-${props.valueB}`);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "seg",
    role: "radiogroup",
    "aria-label": _ctx.ariaLabel
  }, [
    _createElementVNode("input", {
      id: idA.value,
      class: "seg__input",
      type: "radio",
      name: _ctx.name,
      value: _ctx.valueA,
      checked: _ctx.modelValue === _ctx.valueA,
      disabled: _ctx.disabled,
      onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', _ctx.valueA)))
    }, null, 40, _hoisted_2),
    _createElementVNode("input", {
      id: idB.value,
      class: "seg__input",
      type: "radio",
      name: _ctx.name,
      value: _ctx.valueB,
      checked: _ctx.modelValue === _ctx.valueB,
      disabled: _ctx.disabled,
      onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', _ctx.valueB)))
    }, null, 40, _hoisted_3),
    _createElementVNode("div", {
      class: _normalizeClass(["seg__track", {
        'is-a': _ctx.modelValue === _ctx.valueA,
        'is-b': _ctx.modelValue === _ctx.valueB,
        'is-disabled': _ctx.disabled,
        [`seg__track--${props.size}`]: true,
      }])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["seg__thumb", `seg__thumb--${props.size}`]),
        "aria-hidden": "true"
      }, null, 2),
      _createElementVNode("label", {
        class: "seg__item",
        for: idA.value
      }, [
        _createElementVNode("span", {
          class: _normalizeClass(["seg__text", `seg__text--${props.size}`])
        }, _toDisplayString(_ctx.labelA), 3)
      ], 8, _hoisted_4),
      _createElementVNode("label", {
        class: "seg__item",
        for: idB.value
      }, [
        _createElementVNode("span", {
          class: _normalizeClass(["seg__text", `seg__text--${props.size}`])
        }, _toDisplayString(_ctx.labelB), 3)
      ], 8, _hoisted_5)
    ], 2)
  ], 8, _hoisted_1))
}
}

})